import React from 'react';
import { Modal, Button, Collapse, Icon } from 'antd';
import BadgeHeader from './BadgeHeader.jsx'
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase'
import { translate } from 'react-i18next';
const Panel = Collapse.Panel;

class Badges extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      subjectGroups: {},
      groupsLoaded: false,
      completedPanels: []
    }
  }

  componentDidMount() {
  this.props.onRef(this)
}

  getSkillDetails = (level, category) => {
    const subjects = Object.entries(this.props.subject_categories)
    let subjDetail = {}
    subjects.map( subj => {
    if (subj[0] !== '-LE9-DevupCg4ZitZyY8' && subj[0] !== '-LE8znUUbrJ_i5-YZ2tE')
      subjDetail[subj[0]] = {
        name: subj[1].name,
        status: this.checkIfLogged(subj[0], level, category)
      }
    })

    return subjDetail

  }

  checkIfLogged = (group, level, category) => {
    let { logs } = this.props
    logs = logs.filter( log =>
      log[1].atl_category.id == category[0]
      &&
      log[1].level_skill.id == level[0]
      &&
      this.state.subjectGroups[group].includes(log[1].subject.id)
    )
    if(logs.length == 0) {
      return false
    } else {
      return true
    }
  }

  getLevel = (category, detailId) => {
    return new Promise((resolve, reject) => {
      let detail;
      this.props.firebase.database().ref(`/badge_details/${detailId}`).once('value')
      .then(function(snapshot) {
        detail = Object.entries(snapshot.val())
        let skillLevel;
        detail.map( (level, i) => {

          if (level[0] !== 'user_id' && Object.keys(level[1]).every((k) => level[1][k].status)) {
            if (detail[i+1]) {
              skillLevel = detail[i+1][0]
            } else {
              skillLevel = 'Completed'
            }
          }
        })
        if (!skillLevel) {
          skillLevel = detail[0][0]
        }
        if (skillLevel == 'user_id') {
          resolve('Completed')
        } else {
          resolve(skillLevel)
        }
      })
    })
  }

  createBadgesTable = (recreate) => {

    if (recreate) { //Delete existing records before rebuilding
      let badgeDetails  = this.props.badgeDetails
      badgeDetails.map( detail => {
        const detailId = detail.split('/')[2]
        this.props.firebase.database().ref(`/badge_details/${detailId}`).remove()
      })
    }

    const { uid } = this.props
    const atl_cat = Object.entries(this.props.category)
    const lvl = Object.entries(this.props.level_skill)
    let category = {};
    let sbj_cat = {};

    atl_cat.map( cat => {
      category[cat[0]] = {badge_detail_id:0, current_level:lvl[0][0]};
    })

    const badge = this.props.firebase.ref(`badges/${uid}`).set({category:category})
    atl_cat.map( cat => {
      let detail = {user_id: uid};
      lvl.map( level=> {
        detail[level[0]] = this.getSkillDetails(level, cat)
      })
      let obj = this.props.firebase.push('badge_details/',detail)
      this.getLevel(cat, obj.key).then( (level) => {
        this.props.firebase.set(`badges/${uid}/category/${cat[0]}`,
          {badge_detail_id:obj.key, current_level:level})
      })
    })
  }

  componentDidUpdate = (prevProps) => {
    //Build an object to categorise subjects
    const subjects = Object.entries(this.props.subjects)
    if (!this.state.groupsLoaded && subjects.length !== 0) {
      let subjectGroups = {}
      Object.entries(this.props.subjects).map( subject => {
        if (subjectGroups[subject[1].category]) {
          subjectGroups[subject[1].category].push(subject[0])
        } else {
          subjectGroups[subject[1].category] = []
          subjectGroups[subject[1].category].push(subject[0])
        }
      })

      this.setState({subjectGroups, groupsLoaded: true})
    }

    //Creating badges table in DB if user don't have it yet
     if( this.props.category && this.props.level_skill && this.props.subject_categories && this.props.logs && this.props.uid && this.props.badges == null) {
       //Another check if exists
      const { uid } = this.props
      const _this = this
      this.props.firebase.database().ref(`badges/${uid}`)
       .on('value', function(snapshot) {
        if (!snapshot.exists()) {//If does not exist, proceed
          _this.createBadgesTable()
        }})
     }
  }

  getHeader = (categoryId, i) => {
    const { t } = this.props
    const badgeDetail = this.props.badges && this.props.badges[this.props.uid].category[categoryId]
    let details = (this.props.details && badgeDetail) && this.props.details[badgeDetail.badge_detail_id]
    details = details && details[badgeDetail.current_level]
    details = details && Object.entries(details)

    let data = {}
    data.name = this.props.category && this.props.category[categoryId].name
    data.color = this.props.color
    if (badgeDetail && badgeDetail.current_level == 'Completed') {
      data.level = 'Completed'
    } else {
      if (data.level == 'user_id') {
        data.level == 'Completed'
      }
      data.level = (this.props.level_skill && badgeDetail) && this.props.level_skill[badgeDetail.current_level].name
    }

    if (data.level == 'Watch') {
      data.badge = 'none'
      data.nextLevel = 'Bronze'
    } else if (data.level == 'Copy') {
      data.badge = 'Bronze'
      data.nextLevel = 'Silver'
    } else if (data.level == 'Do') {
      data.badge = 'Silver'
      data.nextLevel = 'Gold'
    } else if (data.level == 'Teach') {
      data.badge = 'Gold'
      data.nextLevel = 'Ruby'
    } else if (data.level == 'Completed') {
      data.badge = 'Ruby'
      data.nextLevel == 'Completed'
      let { completedPanels } = this.state
      completedPanels.push(i)
      if (this.state.completedPanels !== completedPanels) {
        this.setState({completedPanels})
      }
    }

    //Count how many for next level
    const totalGroups = details && details.length
    let completed = details && details.filter( element =>
      element[1].status == true
    ).length
    data.remaining = totalGroups-completed

    return (
      <BadgeHeader t={this.props.t} lng={this.props.lng} data={data} />
    )
  }

  getBody = (categoryId) => {
    const { t } = this.props
    const badgeDetail = this.props.badges && this.props.badges[this.props.uid].category[categoryId]
    let details = (this.props.details && badgeDetail) && this.props.details[badgeDetail.badge_detail_id]
    details = details && details[badgeDetail.current_level]
    details = details && Object.entries(details)

    return (
      <div>
        {(details && this.props.subject_categories) && details.map( category => (
        <div style={{borderTop: '1px solid #E0E0E0', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0px'}}>
          <h5 style={{fontFamily: 'Arial Rounded MT Bold', fontSize: 16, color: category[1].status ? this.props.color : '#C9CABF', marginBottom: 0 }}>{this.props.subject_categories[category[0]] && t(this.props.subject_categories[category[0]].name)}</h5>
          {category[1].status && <Icon style={{fontSize: 25, color: '#6AAF28'}} type="check-circle" />}
        </div>
      ))}
      </div>
    )
  }

  addLogToBadges = (data) => {
    //Find which group is the subject
    const subjectId = data.subject.id
    let subjectGroup = Object.entries(this.state.subjectGroups)
    console.log('asdfg', subjectId, subjectGroup);
    subjectGroup = subjectGroup.filter( group =>
      group[1].includes(subjectId)
    )
    subjectGroup = subjectGroup && subjectGroup[0][0]
    const subjectGroupName = this.props.subject_categories[subjectGroup].name
    const categoryId = data.category.id
    const level = data.skill.id
    const { uid } = this.props
    const detailId = this.props.badges[uid].category[categoryId].badge_detail_id
    detailId && this.props.firebase.database().ref(`/badge_details/${detailId}/${level}/${subjectGroup}`).update({
      name: subjectGroupName,
      status: true
    })
    this.getLevel(categoryId, detailId)
      .then( level => {
        this.props.firebase.database().ref(`/badges/${uid}/category/${categoryId}`).update({
          current_level: level
        })
      })
  }

  render() {
    const { t } = this.props
    const categories = Object.entries(this.props.category)

    return (
      <div>
        <Modal
          visible={this.props.open}
          onCancel={this.props.close}
          footer={null}
          style={styles.modal}
          width={540}
          bodyStyle={{minHeight: '100vh', height: '100%'}}
          wrapClassName='badgesModal'
        >
          <h1 style={{color: this.props.color, fontSize: 20, marginTop: -10, textAlign: 'center'}}>{t('My Progress')}</h1>
          <Collapse bordered={false} style={{backgroundColor: 'white'}}>
          {categories && categories.map( (category, i) => (
            <Panel header={this.getHeader(category[0], i)} key={i} showArrow={false} className='badgePanel' disabled={this.state.completedPanels.includes(i)} style={{border: this.state.completedPanels.includes(i) && '2px solid #ffae18'}}>
              {this.getBody(category[0])}
            </Panel>
          ))}
        </Collapse>
        </Modal>
      </div>
    )
  }
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect((props, store) => {
    const { uid } = props
    return ['logs', 'subject_categories', 'subjects', { path: '/badges', queryParams: [ 'orderByKey', `equalTo=${uid}` ] }]
  }),
  connect(
    state => {
      const uid = state.firebase && state.firebase.auth.uid
      let logs = state.firebase.data.logs && Object.entries(state.firebase.data.logs)
        .filter( log =>
          log[1].user_id == uid
        )
      let badgeDetails = []
      state.firebase.data.badges && Object.entries(state.firebase.data.badges[uid].category).map( cat => {
        badgeDetails.push(`/badge_details/${cat[1].badge_detail_id}`)
      })
      return {
        logs,
        badges: state.firebase.data.badges,
        subject_categories: state.firebase.data.subject_categories,
        subjects: state.firebase.data.subjects || {},
        badgeDetails
      }
    }
  ),
  firebaseConnect((props, store) => {
    return props.badgeDetails
  }),
  connect(
    state => {
      return {
        details: state.firebase.data.badge_details || {},
     }
    }
  )
)
export default enhancer(Badges);

const styles = {
  modal: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100vh',
  },
}



// WEBPACK FOOTER //
// ./src/components/Badges/index.jsx